(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("geoLocUtils", [], factory);
	else if(typeof exports === 'object')
		exports["geoLocUtils"] = factory();
	else
		root["geoLocUtils"] = factory();
})(window, function() {
return 